// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"435e8108","718":"7db19fcc","920":"20569891","983":"bd128ca1"}[chunkId] + ".chunk.js";
};